import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthComponentModel } from 'app/modules/common/entities/AuthComponentModel';
import { ChangeTaskModel } from 'app/modules/common/entities/change-task.model';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { TaskSaveModel } from 'app/modules/task/entities/TaskSaveModel';
import { TaskSaveService } from 'app/modules/task/services/task-save.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-tasks-change-popup',
    templateUrl: './tasks-change-popup.component.html',
    styleUrls: ['./tasks-change-popup.component.scss'],
    standalone: false
})
export class TasksChangePopupComponent implements OnInit {

    public taskTypes: any = [];
    public selectedTaskType: any;
    public authComponentModel = new AuthComponentModel();

    form: UntypedFormGroup;

    constructor(
        private fb: UntypedFormBuilder,
        private taskSaveService: TaskSaveService,
        private sharedService: SharedService,
        private dialogRef: MatDialogRef<TasksChangePopupComponent>,
        private selectionService: SelectionGenericService,
        private pageLoaderService: PageLoaderService,
    ) { }

    ngOnInit(): void {

        this.initForm();
        this.getDefTareaForTaskDropdown();
        this.getAuthComponentModel();

    }


    private initForm() {
        this.form = this.fb.group({
            Tarea: null,
            Fecha: null,
            Author: this.fb.group({
                Tipo: null,
                Usuario: null,
                Medico: null,
                Coordinator: null,
                Nombre: null,
                MedicoId: null,
            })
        });
    }


    private getDefTareaForTaskDropdown(): void {
        const companyId = parseInt(localStorage.getItem("Empresa"));
        this.taskSaveService
            .getTaskTypesForCompany(companyId)
            .subscribe(res => {
                if (res.code === 0) {
                    this.taskTypes = res.result;
                } else {
                    this.sharedService.ShowSnackBar("Lo sentimos, la carga de los tipos de tareas ha fallado");
                    console.error(res.message);
                }
            }, error => {
                this.sharedService.ShowSnackBar("Lo sentimos, la carga de los tipos de tareas ha fallado");
                console.error(error);
            });
    }


    public closeDialog() {
        this.dialogRef.close(false);
    }


    private getTaskChangeModel(): ChangeTaskModel {
        const saveModel = new ChangeTaskModel();
        saveModel.Tarea1 = this.selectedTaskType?.espanyol;
        saveModel.Tipo = this.selectedTaskType?.id;
        saveModel.Fecha = DateHelper.getUTCDateString(DateHelper.getNativeDate(this.form.get('Fecha').value));
        saveModel.TipoAutor = this.form.get('Author.Tipo').value;
        saveModel.Autor = this.form.get('Author.Nombre').value;
        saveModel.MedicoId = this.form.get('Author.MedicoId').value;
        saveModel.TasksResults = this.selectionService.taskResultModal;
        return saveModel;
    }


    public onTaskChange(event: { value: any; }): void {
        const selectedDefTareaId = event.value;
        const selectedTask = this.taskTypes.filter((x: { id: any; }) => x.id === selectedDefTareaId)[0];
        this.selectedTaskType = selectedTask;
    }


    public getAuthComponentModel(): void {
        const companyId = parseInt(localStorage.getItem("Empresa"));
        this.taskSaveService
            .getAuthComponentModelForCompany(companyId)
            .subscribe(res => {
                if (res) {
                    this.authComponentModel = res.result;
                }
            });
    }


    public changeTasks() {
        this.form.markAllAsTouched();

        if (!this.validateForm()) {
            this.sharedService.ShowSnackBar("Debe darse al menos un valor");
            return;
        }

        if (!this.form.valid)
            return;

        this.pageLoaderService.ShowPageLoader();
        const saveModel = this.getTaskChangeModel();

        this.selectionService
            .changeTasks(saveModel)
            .pipe(
                finalize(() => this.pageLoaderService.HidePageLoader())
            )
            .subscribe(res => {
                if (res.code === 0) {
                    this.sharedService.ShowSnackBar("Las tareas se han modificado con éxito");
                    this.selectionService.SearchTasks(0, 50, true);
                    this.dialogRef.close(true);
                } else {
                    this.sharedService.ShowSnackBar("Lo siento, el cambio de tareas ha fallado");
                    console.error(res.message);
                }
            }, error => {
                this.sharedService.ShowSnackBar("Lo siento, el cambio de tareas ha fallado");
                console.error(error);
            });
    }


    /**
     * Validate form. At lease one value should be given
     */
    private validateForm(): boolean {
        return this.form.value.Tarea || this.form.value.Fecha || this.form.value.Author.Tipo;
    }

}
